import { nanoid } from "nanoid";
import asArray from "../as-array";
/**
 * Find filters that have `splitValues: true` and split them into multiple instances of the same
 * filter, each with a single selected value.
 */
export function splitFilters(filters) {
    const processed = {};
    Object.values(filters).forEach((filter) => {
        if (filter.splitValues && Array.isArray(filter.selected) && filter.selected.length > 1) {
            filter.selected.forEach((selected) => {
                const withId = addInternalId(filter);
                processed[getFilterKey(withId)] = Object.assign(Object.assign({}, withId), { selected });
            });
        }
        else {
            processed[getFilterKey(filter)] = filter;
        }
    });
    return processed;
}
/**
 * Find filters that have `splitValues: true` and join them into a single instance of the filter
 * with an array of selected values. This is the inverse of `splitFilters`.
 */
export function joinFilters(filters) {
    const joined = {};
    Object.values(filters).forEach((filter) => {
        const key = filter.id;
        if (filter.splitValues) {
            const existing = joined[key];
            const selected = asArray(filter.selected)[0];
            if (existing) {
                existing.selected.push(selected);
            }
            else {
                joined[key] = Object.assign(Object.assign({}, filter), { selected: [selected] });
            }
        }
        else {
            joined[key] = filter;
        }
    });
    return joined;
}
export function addInternalId(filter) {
    return Object.assign(Object.assign({}, filter), { $id: nanoid(8) });
}
export function getFilterKey(filter) {
    return filter.$id || filter.id;
}
